import { FC } from "react";

const ErrorNotFound: FC = () => {
  return (
    <div>
      <h1>404 | Not Found</h1>
    </div>
  );
};

export default ErrorNotFound;
